<template>
  <v-dialog
    :model-value="open"
    content-class="show-modal-popup"
    persistent
    :scrim="'#212121'"
    :opacity="0.65"
    @update:model-value="$emit('update:open', $event)"
  >
    <div class="dialog-root">
      <div class="celebration-circles celebration-circles--fullscreen" aria-hidden="true">
        <span
          v-for="(circle, i) in circles"
          :key="i"
          class="celebration-circle"
          :style="{
            width: circle.size + 'px',
            height: circle.size + 'px',
            left: circle.left + '%',
            animationDuration: circle.duration + 's',
            animationDelay: circle.delay + 's',
            backgroundColor: circle.color
          }"
        />
      </div>
      <v-card class="pa-6 show-modal-popup show-modal-popup__card dialog-card">
        <v-card-title class="text-center pa-0 mb-3">
        <!-- <icon
          class="d-block mx-auto"
          fill="primary"
          height="56"
          width="56"
        >
          check-mark-circle
        </icon> -->
        <p class="text-6xl mb-4">🎆</p>
        <h3 class="text-3xl">Blackout!</h3>
      </v-card-title>
      <v-card-text class="text-center text-body-2 pa-0 mb-3">        
        <p class="mb-2">You filled every square!</p>
        <div class="prize-earned">
          <!-- <span class="prize-icon">🎽</span> -->
          <span class="prize-name">{{ displayPrizeName }} Earned!</span>
        </div>
        <p class="claim-prize-text">Click on the Rewards tab to claim your prize</p>
      </v-card-text>
      <v-card-actions class="flex-column pa-0">
        <v-btn
          color="primary"
          variant="flat"
          size="large"
          rounded
          block
          class="mb-2 show-modal-popup__btn awesome-btn"
          @click="goToRewards"
        >
        🎊 Awesome!
        </v-btn>        
      </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'BlackoutDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    prizeName: {
      type: String,
      default: 'Prize'
    }
  },
  emits: ['update:open'],
  data() {
    return {
      circles: []
    };
  },
  watch: {
    open: {
      handler(isOpen) {
        if (isOpen) this.circles = this.generateCircles();
      },
      immediate: true
    }
  },
  computed: {
    displayPrizeName() {
      return this.prizeName || 'Prize';
    }
  },
  methods: {
    randomBetween(min, max) {
      return min + Math.random() * (max - min);
    },
    pickRandom(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    },
    generateCircles() {
      const colors = [
        '#f99810', '#0f598a', '#e91e63', '#9c27b0', '#ff5722',
        '#00bcd4', '#8bc34a', '#ffeb3b', '#ff9800', '#e53935'
      ];
      return Array.from({ length: 28 }, () => ({
        size: this.randomBetween(6, 22),
        left: this.randomBetween(0, 100),
        duration: this.randomBetween(2.5, 5.5),
        delay: this.randomBetween(0, 2),
        color: this.pickRandom(colors)
      }));
    },
    goToRewards() {
      this.$store.dispatch('cartOrders/resetCart');
      this.$store.dispatch('bingo/clearLastCheckInResult');
      this.$emit('update:open', false);
      this.$nextTick(() => {
        this.$router.push({
          name: 'Rewards',
          query: window.token ? { t: window.token } : {}
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.v-card-text) {
  color: rgba(0, 0, 0, .6) !important;
  padding-top: 6px !important;
  padding-bottom: 20px !important;
  font-size: 0.875rem !important;
}

.v-dialog {
    width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
    width: 100%;
}

@keyframes glow-pulse {
  0%, 100% {
    box-shadow: 0 0 20px rgba(249, 152, 16, 0.4), 0 0 40px rgba(249, 152, 16, 0.2);
  }
  50% {
    box-shadow: 0 0 30px rgba(249, 152, 16, 0.6), 0 0 60px rgba(249, 152, 16, 0.3);
  }
}

@keyframes fall {
  from {
    transform: translateY(-100%);
    opacity: 1;
  }
  to {
    transform: translateY(100vh);
    opacity: 0.6;
  }
}

.dialog-root {
  position: relative;
}

.dialog-card {
  position: relative;
  z-index: 1;
}

.celebration-circles {
  pointer-events: none;
}

.celebration-circles--fullscreen {
  position: fixed;
  inset: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 0;
}

.celebration-circle {
  position: absolute;
  top: -30px;
  border-radius: 50%;
  animation: fall 4s linear infinite;
}

.show-modal-popup {  
  &__card {
    max-width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
    max-height: 94%;
    margin: 0;
    border-radius: 1rem !important;
    animation: glow-pulse 2s ease-in-out infinite;
  }

  h3 {  
    font-size: 1.875rem;
    line-height: 2.25rem;
    margin-bottom: .5rem;
    letter-spacing: -.025em;
    font-weight: 900;
  }
}

:deep(.v-overlay__content) {  
  max-height: calc(100vh - 48px);
  max-width: min(480px, calc(100vw - 48px));
  padding: 2rem;
}

.awesome-btn {
  border-radius: .75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  padding-top: .875rem;
  padding-bottom: .875rem;
  height: auto !important;
  min-height: unset !important;
}
.text-6xl {
    font-size: 3.75rem;
    line-height: 1;
}



.v-dialog > .v-overlay__content .dialog-card {
    padding: 2rem !important;
}

.show-modal-popup h3 {
    color: #1b2632;
    letter-spacing: -.025em;
    font-weight: 900;
    font-size: 1.875rem;
    line-height: 2.25rem;
}

.v-card .v-card-text {
    padding: 0 !important;
    margin: 0 !important;
}

.v-card .v-card-text p {
    color: #737f8c;
    font-size: 1rem !important;
    line-height: 1.5rem !important;
    margin-bottom: .5rem;
}

.prize-earned {
    background: #f9981033;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    padding-top: .5rem !important;
    padding-bottom: .5rem !important;
    border-radius: 9999px;
    width: fit-content;
    margin: 0 auto 1.5rem;
    display: flex;
    align-items: center;
    gap: .5rem;
}

span.prize-icon {
    font-size: 1.125rem;
    line-height: 1.75rem;
    /* padding-right: .5rem; */
}

span.prize-name {
    color: #f99810;
    font-weight: 700;
    font-size: .875rem;
    line-height: 1.25rem;
}

.v-card p.claim-prize-text {
    color: #737f8c !important;
    font-size: .75rem !important;
    line-height: 1rem !important;
}


.awesome-btn {
    background-color: #0f598a !important;
    font-size: 1rem !important;
    line-height: 1.5rem !important;
}

.v-overlay__content {
    /* padding: 0  !important; */
    margin: 0 auto !important;
}

.v-overlay {
    margin: 0 !important;
}
</style>
